import o from 'react';
import { CampaignContext } from './src-context-CampaignContext.js';

const useCampaignContext = () => {
  return o.useContext(CampaignContext);
};

export { useCampaignContext };
//# sourceMappingURL=src-hooks-useCampaignContext.js.map
